<template>
  <div class="installment pb-9">
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">مدیریت اقساط</h4>
        <v-divider class="me-10 ms-10 d-none d-md-block" vertical></v-divider>
        <div class="custom-input2 mt-3 mt-md-0">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو در نوع قسط بندی..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col
              cols="12"
              xl="10"
              lg="10"
              md="10"
              sm="8"
              xs="12"
              class="d-flex flex-row"
            >
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="4" xs="12">
              <v-btn
                @click="openNewinstallment()"
                @shortkey="openNewinstallment()"
                v-shortkey.once="['n']"
                class="purple-borderedBtn"
                height="43"
                block
              >
                <v-icon class="me-1">mdi-cash-plus</v-icon>افزودن قسط جدید
              </v-btn>
            </v-col>
          </v-row>
          <hr />
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedItems"
              :fields="installmentFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(duration)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(prepaymentRate)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(interestRate)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(minimumPrice)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }} تومان
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    class="green-mainBtn mb-2"
                    block
                    height="36"
                    @click="openEditDialog(row.item)"
                  >
                    ویرایش</v-btn
                  >
                  <v-btn
                    class="red-mainBtn"
                    block
                    height="36"
                    @click="openDeletDialog(row.item)"
                  >
                    حذف</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <div class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </div>
              </v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2"> برو به صفحه </span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="whichPage"
                    type="number"
                    @change="goToPage()"
                    @click="goToPage()"
                    :items="computedIndex"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="text-sm-center">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedItems.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-sm-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>

    <v-dialog v-model="newinstallmentDialog" width="600">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row class="title-modal">
            <v-col>
              <h4>ثبت قسط جدید</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-1">
              <span class="pointer" @click="cancelinstallment()"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-1 mb-2" />

        <v-card-text class="pa-2">
          <v-row>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نوع قسط بندی :</label
              >
              <v-text-field
                placeholder="نوع قسط بندی"
                outlined
                dense
                v-model="newinstallment.title"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> تعداد قسط :</label
              >
              <v-text-field
                placeholder="تعداد قسط "
                outlined
                dense
                v-model="newinstallment.duration"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> درصد پیش پرداخت :</label
              >
              <v-text-field
                placeholder="درصد پیش پرداخت"
                outlined
                dense
                v-model="newinstallment.prepaymentRate"
                :error-messages="newprepaymentRateErrors"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> درصد سود :</label
              >
              <v-text-field
                placeholder="درصد سود"
                outlined
                dense
                v-model="newinstallment.interestRate"
                :error-messages="newpreinterestRateErrors"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> حداقل سبدخرید :</label
              >
              <vuetify-money
                v-model.number="newinstallment.minimumPrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                type="number"
                outlined
                label="حداقل سبدخرید(تومان)"
              />
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                class="red-mainBtn white--text"
                @click="cancelinstallment()"
                block
              >
                لغو
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                @click="addinstallment()"
                :disabled="busy || !isValidNewinstallment"
                class="green-mainBtn white--text"
                block
              >
                <atom-spinner
                  v-if="busy"
                  :animation-duration="1000"
                  :size="20"
                  :color="'#fff'"
                />
                <span v-else>افزودن</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editinstallmentDialog" width="600">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row class="title-modal">
            <v-col>
              <h4>
                ویرایش قسط <span>{{ editinstallment.name }}</span>
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-1">
              <span class="pointer" @click="editinstallmentDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-1 mb-2" />
        <div
          v-if="loading2"
          class="d-flex flex-column align-items-center mt-8 py-6"
        >
          <atom-spinner
            :animation-duration="1000"
            :size="50"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
        <v-card-text class="pa-2" v-else>
          <v-row>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نوع قسط بندی :</label
              >
              <v-text-field
                placeholder="نوع قسط بندی"
                outlined
                dense
                v-model="editinstallment.title"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> تعداد قسط :</label
              >
              <v-text-field
                placeholder="تعداد قسط "
                outlined
                dense
                v-model="editinstallment.duration"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> درصد پیش پرداخت :</label
              >
              <v-text-field
                placeholder="درصد پیش پرداخت"
                outlined
                dense
                v-model="editinstallment.prepaymentRate"
                :error-messages="editprepaymentRateErrors"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12" md="6" sm="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> درصد سود :</label
              >
              <v-text-field
                placeholder="درصد سود"
                outlined
                dense
                v-model="editinstallment.interestRate"
                :error-messages="editpreinterestRateErrors"
              ></v-text-field>
            </v-col>
            <v-col class="py-0" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> حداقل سبدخرید :</label
              >
              <vuetify-money
                v-model.number="editinstallment.minimumPrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                type="number"
                outlined
                label="حداقل سبدخرید(تومان)"
              />
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                class="red-mainBtn white--text"
                @click="editinstallmentDialog = false"
                block
              >
                لغو
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                @click="doEditinstallment()"
                :disabled="editLoading || !isValidEditinstallment"
                class="green-mainBtn white--text"
                block
              >
                ویرایش
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteinstallmentDialog" width="400">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row class="title-modal">
            <v-col>
              <h4>
                حذف قسط <span>{{ editinstallment.title }}</span>
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-1">
              <span class="pointer" @click="deleteinstallmentDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-1 mb-2" />
        <div v-if="loading2" class="d-flex flex-column align-items-center">
          <atom-spinner
            :animation-duration="1000"
            :size="40"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
        <v-card-text class="pa-2" v-else>
          <v-row>
            <v-col cols="12" class="content-modal-publisher">
              <h4>
                آیا از حذف قسط <span>{{ editinstallment.title }}</span
                >اطمینان دارید؟
              </h4>
            </v-col>

            <v-col cols="12" md="6" sm="12">
              <v-btn
                class="red-mainBtn white--text"
                @click="deleteinstallmentDialog = false"
                block
              >
                لغو
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn
                @click="doDeletinstallment()"
                :disabled="deleteLoading"
                class="green-mainBtn white--text"
                block
              >
                بلی
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      tab: null,
      filter: "",
      guide: false,
      busy: false,
      editLoading: false,
      deleteLoading: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      newpreinterestRateErrors: [],
      newprepaymentRateErrors: [],
      editpreinterestRateErrors: [],
      editprepaymentRateErrors: [],
      installment: [],
      editinstallmentImage: {},
      installmentImage: {},
      editinstallmentImageLoading: false,
      installmentImageLoading: false,
      newinstallment: {},
      editinstallment: {},
      selectedinstallment: {},
      newinstallmentDialog: false,
      editinstallmentDialog: false,
      deleteinstallmentDialog: false,
      loading: false,
      loading2: false,
      installmentFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "نوع قسط‌ بندی " },
        { key: "duration", label: "تعداد قسط‌" },
        { key: "prepaymentRate", label: "درصد پیش پرداخت" },
        { key: "interestRate", label: "درصد سود " },
        { key: "minimumPrice", label: "حداقل سبدخرید " },
        { key: "operation", label: "عملیات" },
      ],
      whichPage: 1,
    };
  },
  watch: {
    "newinstallment.interestRate": function (newVal) {
      this.newpreinterestRateErrors = [];
      if (newVal < 1 || newVal > 100 || !Number.isInteger(Number(newVal))) {
        this.newpreinterestRateErrors.push(" باید عدد صحیح بین 1 تا 100 باشد.");
      }
    },
    "newinstallment.prepaymentRate": function (newVal) {
      this.newprepaymentRateErrors = [];
      if (newVal < 1 || newVal > 100 || !Number.isInteger(Number(newVal))) {
        this.newprepaymentRateErrors.push(" باید عدد صحیح بین 1 تا 100 باشد.");
      }
    },
    "editinstallment.interestRate": function (newVal) {
      this.editpreinterestRateErrors = [];
      if (newVal < 1 || newVal > 100 || !Number.isInteger(Number(newVal))) {
        this.editpreinterestRateErrors.push(
          " باید عدد صحیح بین 1 تا 100 باشد."
        );
      }
    },
    "editinstallment.prepaymentRate": function (newVal) {
      this.editprepaymentRateErrors = [];
      if (newVal < 1 || newVal > 100 || !Number.isInteger(Number(newVal))) {
        this.editprepaymentRateErrors.push(" باید عدد صحیح بین 1 تا 100 باشد.");
      }
    },
  },
  computed: {
    computedItems() {
      let filtered;
      filtered = this.installment.filter((x) => x.title.includes(this.filter));
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedItems.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    isValidEditinstallment() {
      return (
        this.editpreinterestRateErrors.length === 0 &&
        this.editprepaymentRateErrors.length === 0
      );
    },
    isValidNewinstallment() {
      return (
        this.newinstallment.title &&
        this.newinstallment.duration &&
        this.newinstallment.prepaymentRate &&
        this.newinstallment.interestRate &&
        this.newinstallment.minimumPrice &&
        this.newpreinterestRateErrors.length === 0 &&
        this.newprepaymentRateErrors.length === 0
      );
    },
  },
  mounted() {
    this.showinstallment();
  },
  methods: {
    openNewinstallment() {
      this.newinstallmentDialog = true;
    },
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },

    showinstallment() {
      this.loading = true;
      Axios.get(this.baseUrl + "/satrapp/shop/installmentPayments/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.installment = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },

    addinstallment() {
      if (!this.isValidNewinstallment) return;
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/installmentPayment/new",
        {
          title: this.newinstallment.title,
          duration: this.newinstallment.duration,
          prepaymentRate: this.newinstallment.prepaymentRate,
          interestRate: this.newinstallment.interestRate,
          minimumPrice: this.newinstallment.minimumPrice,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newinstallment = {
              title: "",
              duration: "",
              prepaymentRate: "",
              interestRate: "",
              minimumPrice: "",
            };
            this.newinstallmentDialog = false;
            this.showinstallment();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.newinstallmentDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
          this.newinstallmentDialog = false;
        });
    },
    cancelinstallment() {
      this.newinstallmentDialog = false;
      this.newinstallment = {};
    },
    openEditDialog(item) {
      this.selectedinstallment = item.id;
      this.getinstallmentInfo();
      this.editinstallmentDialog = true;
    },
    getinstallmentInfo() {
      this.loading2 = true;
      Axios.get(
        this.baseUrl +
          "/satrapp/shop/installmentPayment/getData/" +
          this.selectedinstallment,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.editinstallment = res.data;
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading2 = false;
        });
    },

    doEditinstallment() {
      if (!this.isValidEditinstallment) return;

      this.editLoading = true;
      Axios.patch(
        this.baseUrl +
          "/satrapp/shop/installmentPayment/edit/" +
          this.selectedinstallment,
        {
          title: this.editinstallment.title,
          duration: this.editinstallment.duration,
          prepaymentRate: this.editinstallment.prepaymentRate,
          interestRate: this.editinstallment.interestRate,
          minimumPrice: this.editinstallment.minimumPrice,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.editLoading = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.showinstallment();
            this.editinstallmentDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");

            this.editinstallmentDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.editLoading = false;
          this.editinstallmentDialog = false;
        });
    },
    openDeletDialog(item) {
      this.selectedinstallment = item.id;
      this.getinstallmentInfo();
      this.deleteinstallmentDialog = true;
    },
    doDeletinstallment() {
      this.deleteLoading = true;
      Axios.delete(
        this.baseUrl +
          "/satrapp/shop/installmentPayment/delete/" +
          this.selectedinstallment,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.deleteLoading = false;
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.showinstallment();
            this.deleteinstallmentDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.deleteinstallmentDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.deleteLoading = false;
          this.deleteinstallmentDialog = false;
        });
    },
  },
};
</script>
<style lang="scss">
.installment {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
}

.product-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #7c4dff !important;
        cursor: pointer;
      }
    }
  }
}
.img-box-installment {
  border-radius: 30px;
  position: relative;
  overflow: hidden;
  width: 170px;
  height: 170px;
  border: none;

  &:hover {
    background-color: #3c03923b !important;
    .img {
      opacity: 0.7;
    }

    .img-icon {
      display: block;
    }
  }

  .img {
    opacity: 1;
    width: 100%;
    height: 100%;
  }
  .img-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }
  .img-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #3c03923b;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>
